// import moment from "moment"
const initial = {
  currentCompetition() {
    return {}
  },
  hasEnteredCompetition() {
    return false
  },
  hasClosed(){
    return false
  }
}

const state = {
  currentCompetition: initial.currentCompetition(),
  hasEnteredCompetition: initial.hasEnteredCompetition(),
  hasClosed: initial.hasClosed()
}

const mutations = {
  RESET_COMPETITIONS(state) {
    state.currentCompetition = Object.assign({}, initial.currentCompetition())
  },
  SET_CURRENT_COMPETITION(state, current) {
    state.currentCompetition = current
  },
  SET_HAS_ENTERED_COMPETITION(state, entered) {
    state.hasEnteredCompetition = entered
  },
  SET_HAS_CLOSED(state, closed) {
    state.hasClosed = closed
  }
}

const actions = {
  reset: ({
    commit
  }) => commit('RESET_COMPETITIONS'),
  setCurrentCompetition: ({
    commit
  }, current) => commit('SET_CURRENT_COMPETITION', current),
  setHasEnteredCompetition: ({
    commit
  }, entered) => commit('SET_HAS_ENTERED_COMPETITION', entered),
  setHasClosed: ({
    commit
  }, closed) => {
    commit('SET_HAS_CLOSED', closed);
    window.localStorage.setItem('comp_banner_closed', true)
  },
}

const getters = {
  currentCompetition: state => state.currentCompetition,
  hasEnteredCurrentCompetition: state => state.hasEnteredCompetition,
  // showCompetitionBanner: state => {
  //   let canEnter = moment() < moment(state.currentCompetition.start_date).date(15)
  //   let hasFreeSpaces = state.currentCompetition.contestants_count < state.currentCompetition.max_contestants
  //   let hasClosedBannerPopup = window.localStorage.getItem('comp_banner_closed') == 'true' ? true: false
  //   if(canEnter && hasFreeSpaces && !state.hasEnteredCompetition && !(state.hasClosed || hasClosedBannerPopup) ) {
  //     return true
  //   }else return false
  // },
  showCompetitionBanner: (state) => (routePath) => {
    let hasClosedBannerPopup = window.localStorage.getItem('comp_banner_closed') == 'true' ? true : false;
    // Check if the banner has not been closed and route path is not "competition"
    if (!(state.hasClosed || hasClosedBannerPopup) && !routePath.includes('competition')) {
      return true;
    } else {
      return false;
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
